import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M21.25 12C14.8264 12 12 14.8264 12 21.25C12 14.8264 9.17361 12 2.75 12C9.17361 12 12 9.17361 12 2.75C12 9.17361 14.8264 12 21.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSparkle;
